import apiFetch from '../apiFetch'

export default function (token, values) {
  return apiFetch({endPoint: `Albaran/getVerracosExtraccionAlbaran`, method: 'POST', body: values, token: token})
}